import React from 'react'
import Paper from '@material-ui/core/Paper'
import InputBase from '@material-ui/core/InputBase'
import Typography from '@material-ui/core/Typography'
import NumberFormat from 'react-number-format'
import { CurrencyFormatter } from 'Utilities/TextFormatter'

import classes from './TextFieldCurrency.module.scss'
export default function TextFieldCurrency(props) {
  const { label = '', required, currency = true, readOnly, error, onChange, ...other } = props

  const [focus, setFocus] = React.useState()

  const handleOnChange = e => {
    if (typeof onChange === 'function') onChange({ target: { value: e.floatValue } })
  }

  return (
    <div className={classes.root}>
      <Typography variant='subtitle2' className={classes.label}>
        {label}
        {!readOnly && required ? ' *' : ''}
      </Typography>
      <div className={classes.wrapper}>
        {readOnly ? (
          //  Read Only Value
          <Typography id={props.id} variant='subtitle2' className={`${classes.label} ${classes['read-only-value']}`}>
            {CurrencyFormatter(other.value)}PHP
          </Typography>
        ) : (
          <React.Fragment>
            <Paper
              className={`${classes['text-field']} ${error ? classes['has-error'] : focus && classes.focus
                } box-shadow-field`}
            >
              <NumberFormat
                id={props.id}
                className={classes.input}
                required
                customInput={InputBase}
                isNumericString
                displayType={'input'}
                thousandSeparator
                decimalScale={2}
                fixedDecimalScale
                allowLeadingZeros={false}
                value={other.value}
                onValueChange={handleOnChange}
                isAllowed={values => {
                  const { floatValue } = values
                  return floatValue <= 10000000000000
                }}
                autoComplete='off'
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
              // {...other}
              />
              {currency && (
                <div className={classes.currency}>
                  <Typography variant='subtitle2' className={classes.label}>
                    PHP
                  </Typography>
                </div>
              )}
            </Paper>
            {error && <span className={classes.error}>{error}</span>}
          </React.Fragment>
        )}
      </div>
    </div>
  )
}
